'use client';

import { Grid2, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { icons } from '@/assets/icons';
import { CoreServiceCard } from '@/components/bases/CoreServiceCard';

const SERVICE_TAGS = [
  { icon: icons.ic_element_1, text: 'One dashboard' },
  { icon: icons.ic_receipt_2, text: 'One invoice' },
  { icon: icons.ic_global, text: 'Global coverage' },
];

const SERVICE_CARDS = [
  {
    id: 1,
    icon: icons.ic_buildings,
    title: 'Employer of Record (EOR)',
  },
  {
    id: 2,
    icon: icons.ic_document_copy,
    title: 'Contractor Management (COR)',
  },
  {
    id: 3,
    icon: icons.ic_cards,
    title: 'Payroll & Payments',
  },
  {
    id: 4,
    icon: icons.ic_shield_tick,
    title: 'Compliance & Local Employment',
  },
];

export const CoreServicesSection = () => {
  return (
    <Stack
      id='core-services'
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      paddingX={{ xs: '24px', sm: '80px' }}
      paddingY={{ xs: '32px', sm: '80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack gap={{ xs: 5, sm: 10 }} width={'min(1280px, 100%)'} zIndex={2}>
        {/* Title */}
        <Stack alignItems={'center'} gap={{ xs: 3, sm: 5 }}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            fontSize={{ xs: '20px', sm: '36px' }}
            lineHeight={{ xs: '24px', sm: '48px' }}
            textAlign={'center'}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            CORE SERVICES
          </Typography>

          {/* Tags */}
          <Stack
            direction={{ xs: 'row', sm: 'row' }}
            alignItems={'center'}
            justifyContent={'center'}
            gap={{ xs: '16px', lg: 0 }}
            flexWrap={'wrap'}
            paddingX={{ xs: 0, sm: '16px' }}>
            {SERVICE_TAGS.map((tag, index) => (
              <Stack key={index} direction={'row'} alignItems={'center'} gap={2}>
                <Image src={tag.icon} alt={tag.text} width={24} height={24} className={'w-5 h-5 sm:w-6 sm:h-6'} />
                <Typography
                  fontSize={{ xs: '14px', sm: '18px' }}
                  variant={'bodyLarge'}
                  color={'#FFFFFF'}
                  sx={{ opacity: 0.65 }}>
                  {tag.text}
                </Typography>
                {index < SERVICE_TAGS.length - 1 && (
                  <Stack
                    width={'0px'}
                    marginX={{ xs: 0, sm: '60px' }}
                    height={{ xs: '16px', sm: '24px' }}
                    sx={{ borderLeft: '1px solid rgba(255, 255, 255, 0.3)' }}
                  />
                )}
              </Stack>
            ))}
          </Stack>
        </Stack>

        {/* Service Cards */}
        <Grid2 container spacing={{ xs: 2, sm: 4 }} width={'100%'}>
          {SERVICE_CARDS.map(card => (
            <Grid2 size={{ xs: 6, sm: 3 }} key={card.id}>
              <CoreServiceCard item={card} />
            </Grid2>
          ))}
        </Grid2>
      </Stack>
    </Stack>
  );
};
